import { useEffect, useState } from "react";

// Hook to fetch validation status
const useErrorStatus = (woocommerce_product_id) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await fetch(`/api/v1/indicator-errors/exhibitor-product/${woocommerce_product_id}`);
        const data = await res.json();
        if (data.success) setStatus(data.data);
      } catch (err) {
        console.error("Error fetching indicator status", err);
      }
    };

    if (woocommerce_product_id) fetchStatus();
  }, [woocommerce_product_id]);

  return status;
};

// Red dot style
const RedDot = () => (
  <span
    style={{
      position: 'absolute',
      top: -4,
      right: -4,
      width: 10,
      height: 10,
      backgroundColor: 'red',
      borderRadius: '50%',
      border: '2px solid white',
      zIndex: 2,
    }}
  />
);

// Main indicator component
const ErrorIndicatorIcon = ({ icon, type, status, product }) => {
  let hasError = false;

  if (type === 'edit' && product) {
    const requiredFields = ['product_name', 'price', 'description', 'category'];
    hasError = requiredFields.some(field =>
      product[field] === null || product[field] === undefined || product[field] === ''
    );
  } else {
    hasError = status?.[type] === false; // updated from 'no' to `false` as per your response
  }

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      {icon}
      {hasError && <RedDot />}
    </div>
  );
};

export { useErrorStatus, ErrorIndicatorIcon };
